export default __webpack_public_path__ + "static/media/VerticalMenuDots.296de7de.svg";